<template>
<div style="height:100%;" v-loading="isLoading">
  <div class="goback-large">
    <i class="fal fa-arrow-left c-pointer" @click="onBackToHomeButton"></i> {{wizardTitle}}
  </div>
  <el-steps :active="activeStep" finish-status="success">
    <el-step v-for="(step, index) in stepTitles" :key="index" :title="step"></el-step>
  </el-steps>
  <!-- 1.서비스 기본 정보 -->
  <div v-show="activeStep === 1">
    <el-row type="flex" justify="space-between" class="title-bar">
      <div class="title-h3">서비스 정보 입력</div>
      <el-button type="primary" @click="onNextLayerButton">다음단계</el-button>
    </el-row>
    <hr class="mr-b20" style="margin-top:0;" />
    <el-form :model="formData" ref="formData" :rules="rules">
      <el-row type="flex">
        <el-col :span="12">
          <el-form-item label="서비스명" prop="objName">
            <el-input placeholder="서비스명을 입력해주세요" v-model="formData.objName"></el-input>
          </el-form-item>
          <el-form-item style="padding-top: 10px;" label="서비스 설명" prop="serviceDesc">
            <el-input placeholder="서비스 설명을 입력해주세요" type="textarea" v-model="formData.serviceDesc" :rows="4"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
  <!-- 2.서비스 장비 연결 -->
  <div v-show="activeStep === 2" :class="$style['step-view']">
    <el-row type="flex" justify="space-between" class="title-bar">
      <div class="title-h3">[{{targetTitle}}] 서비스 장비 연결</div>
      <div>
        <el-button @click="onBackLayerButton">전단계</el-button>
        <el-button type="primary" @click="onSaveButton" :disabled="serviceObjList.length === 0">등록 완료</el-button>
        <el-button type="secondary" @click="onSettingObjRscLayer" :disabled="serviceObjList.length === 0">자원 설정</el-button>
      </div>
    </el-row>
    <hr class="mr-b20" style="margin-top:0;" />
    <div :class="$style['step-content']">
      <!-- <div :class="$style['tree-box']">
        <el-row type="flex" justify="space-between" class="title-bar">
          <div class="vertical-center-box">
            <div class="title-h4 mr-r10">관리 대상</div>
            <el-select style="width:120px;" v-model="targetManagetypeId" @change="onChangeManagetypeId">
              <el-option v-for="item in managetypeList" :key="item.managetypeId" :label="item.managetypeName" :value="item.managetypeId"></el-option>
            </el-select>
            <el-select class="mr-l4" style="width:110px;" v-show="targetManagetypeId === 'NMS'" v-model="managetypeKey">
              <el-option v-for="item in managetypeKeyList" :key="item.managetypeKey" :label="item.managetypeKeyName" :value="item.managetypeKey"></el-option>
            </el-select>
          </div>
          <w-search-field ref="targetSearchField" width="200px" @search="filterTargetTree" />
        </el-row>
        <div style="height:calc(100% - 38px);">
          <el-scrollbar class="bar-visible">
            <w-check-physical-tree v-if="reloadFlag" :ref="targetTreeRef" :managetype-id="targetManagetypeId" :managetype-key="managetypeKey" @checked="onClickNode" :show-search-tool="false" />
          </el-scrollbar>
        </div>
      </div> -->
      <w-physical-obj-table :class="$style['tree-box']" :managetype-data="managetypeList" :checked-obj-list="serviceObjList" ref="physicalObjTable"
      :active="activeStep === 2" :fit-height="true" style="height:calc(100% - 38px)" />
      <!-- <div :class="$style['add-btn-box']">
        <el-row class="vertical-center-box" style="height:100%;" type="flex" justify="center" align="center">
          <el-button icon="el-icon-arrow-right" @click="onAddSelectedData"></el-button>
        </el-row>
      </div> -->
      <div :class="$style['drag-box']">
        <div class="title-bar title-h4">서비스 장비 목록</div>
        <div style="height:calc(100% - 26px);">
          <el-scrollbar class="bar-visible">
            <draggable v-model="serviceObjList" class="list-drag-box" element="ul" @start="isDraggable=true" @end="isDraggable=false">
              <li v-for="element in serviceObjList" :key="element.objId">
                <div class="label">{{element.objName}}</div>
                <i :class="[$style['close-icon'], 'fal fa-times', 'c-pointer']" @click="onDeleteServiceObj(element)"></i>
              </li>
            </draggable>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
  <!-- 3.서비스 장비 자원 설정 -->
  <div v-show="activeStep === 3" :class="$style['step-view']">
    <el-row class="title-bar veritcal-center-box" type="flex" justify="space-between">
      <div class="title-h4">[{{targetTitle}}] 장비 자원 설정</div>
      <div>
        <el-button @click="onBackLayerButton">이전</el-button>
        <el-button type="primary" @click="onSaveButton">등록 완료</el-button>
      </div>
    </el-row>
    <hr class="mr-b20" style="margin-top:0;" />
    <div :class="$style['step-content']">
      <div :class="$style['tree-box']">
        <el-row type="flex" justify="space-between" class="title-bar">
          <div class="title-h4">장비 자원</div>
          <w-search-field ref="rscSearchField" width="200px;" @search="filterRscTree" />
        </el-row>
        <div style="height:calc(100% - 38px);" v-loading="staticTreeLoadingFlag">
          <el-scrollbar class="bar-visible">
            <el-tree class="tree-checkbox" ref="rscTreeRef"
              v-if="rscReloadFlag"
              :data="treeData"
              :props="defaultProps"
              node-key="treeKey"
              show-checkbox
              :expand-on-click-node="false"
              highlight-current
              :filter-node-method="rscFilterNode">
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
      <div :class="$style['add-btn-box']">
        <el-row class="vertical-center-box" style="height:100%;" type="flex" justify="center" align="center">
          <el-button icon="el-icon-arrow-right" @click="onAddSelectedData"></el-button>
        </el-row>
      </div>
      <div :class="$style['drag-box']">
        <div class="title-bar title-h4">서비스 장비 자원 목록</div>
        <el-table :data="rscTableData" style="width: 100%;" height="calc(100% - 26px)">
          <el-table-column label="장비명" prop="objName"></el-table-column>
          <el-table-column label="자원 종류" prop="rsctypeName"></el-table-column>
          <el-table-column label="자원" prop="label"></el-table-column>
          <el-table-column width="50">
            <template slot-scope="scope">
              <i :class="[$style['close-icon'], 'fal fa-times', 'c-pointer']" @click="onDeleteServiceObj(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import msgUtil from '@/utils/message';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import TreeFilter from '@/mixins/tree/filter';
import { defaultProps } from '@/constants/tree';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
import forEach from 'lodash/forEach';
import isUndefined from 'lodash/isUndefined';
import cloneDeep from 'lodash/cloneDeep';
import findIndex from 'lodash/findIndex';
import DeviceRegistrationSvcAPI from '@/api/settings/common/device-registration-svc';
import draggable from 'vuedraggable';
import WCheckPhysicalTree from '@/components/tree/CheckPhysicalTree';
import WSearchField from '@/components/form/SearchField';
import managetypeKeyApi from '@/api/model/managetype-key';
import WPhysicalObjTable from '@/components/table/PhysicalObjTable';

const noServiceItemManagetypes = ['EMS', 'FMS', 'SVC', 'VMS', 'APM2X'];
export default {
  name: 'WServiceRegistWizard',
  mixins: [TreeFilter],
  components: {
    WSettingsContentTemplate,
    draggable,
    WCheckPhysicalTree,
    WSearchField,
    WPhysicalObjTable,
  },
  data() {
    return {
      isLoading: false,
      wizardTitle: '서비스 등록 마법사',
      managetypeKeyList: [],
      rscKeyword: null,
      activeStep: 1,
      stepTitles: ['서비스 생성', '자원 및 장비 연결', '자원 설정'],
      rscTableData: [],
      rscTableDataOrigin: [],
      updateOrderbyServiceObjList: [],
      reloadFlag: false,
      rscReloadFlag: false,
      selectedData: [],
      serviceObjList: [],
      serviceObjListOrigin: [],
      checkedObjList: [],
      defaultProps,
      targetTitle: '',
      managetypeId: '',
      targetTreeRef: 'treeRef',
      targetManagetypeId: '',
      wizardMode: 'add',
      formData: {
        objName: '',
        serviceDesc: null,
      },
      staticTreeLoadingFlag: false,
      formDataOrigin: {},
      rules: {
        objName: {
          required: true,
          trigger: 'blur',
          message: '값을 입력해주세요',
        },
      },
      rscTreeRef: 'rscTreeRef',
      removeServiceObjList: [],
      removeRscTableData: [],
      managetypeKey: null,
      treeData: [],
    };
  },
  computed: {
    managetypeList() {
      return filter(this.$store.getters.activeManagetypesToShow, (item) => noServiceItemManagetypes.indexOf(item.managetypeId) < 0);
    },
  },
  watch: {
    /**
     * 관리 구분 바인딩 시 첫번째 관리 구분이 자동으로 선택되도록 한다.
     * @author Ju
     * @param  {[type]} to [description]
     */
    managetypeList: {
      immediate: true,
      handler(to) {
        if (!isEmpty(to)) {
          this.managetypeId = this.managetypeList[0].managetypeId;
        }
      },
    },
    serviceObjList: {
      handler() {
        this.checkedObjList = cloneDeep(this.serviceObjList);
      },
    },
  },
  methods: {
    // 등록 마법사 수정 시 데이터 바인딩 함수
    onSettingByWizardMode(wizardMode, item) {
      if (this.$refs.targetSearchField) {
        this.$refs.targetSearchField.clear();
      }
      if (this.$refs.rscSearchField) {
        this.$refs.rscSearchField.clear();
      }

      this.wizardMode = wizardMode;
      this.removeServiceObjList = [];
      this.removeRscTableData = [];
      this.reload();
      if (wizardMode === 'update') {
        this.wizardTitle = '서비스 정보 수정';
        // 1-layer 정보
        this.formData.objName = item.objName;
        this.formData.serviceDesc = item.serviceDesc;
        this.formData.objId = item.objId;
        this.formDataOrigin = cloneDeep(this.formData);
        // 장비 연결 - api 호출 및 treeKey 체크
        DeviceRegistrationSvcAPI.getTargetServiceConfig({
          objId: item.objId,
        }).then((res) => {
          if (res.data.success) {
            this.serviceObjList = res.data.data;
            this.serviceObjListOrigin = cloneDeep(res.data.data);
          }
        });

        // 자원 연결 - api 호출 및 treeKey 체크
        DeviceRegistrationSvcAPI.getTargetServiceObjRscKey({
          objId: item.objId,
        }).then((res) => {
          if (res.data.success) {
            this.rscTableData = res.data.data;
            this.rscTableDataOrigin = cloneDeep(res.data.data);
          }
        });
      } else {
        this.wizardTitle = '서비스 등록 마법사';
      }
    },
    onBackLayerButton() {
      this.activeStep -= 1;
      if (this.activeStep === 2) {
        this.$refs.targetSearchField.clear();
      }
      this.reload();
    },
    onNextLayerButton() {
      this.$refs.formData
        .validate()
        .then((res) => {
          if (res) {
            this.activeStep = 2;
            this.targetTitle = `${this.formData.objName}`;
            if (!isEmpty(this.managetypeList)) {
              this.onChangeManagetypeId(this.managetypeList[0].managetypeId); // 장비목록 트리 reload
            }
          }
        })
        .catch(() => {});
    },
    // 등록 마법사 종료
    onBackToHomeButton() {
      this.onChangeManagetypeId = null;
      this.rscReloadFlag = false; // 자원목록 트리 reload
      this.rscTableData = [];
      this.serviceObjList = [];
      this.activeStep = 1;
      this.wizardMode = 'add';
      this.$refs.formData.resetFields();
      this.$emit('on-back-to-home-button');
    },
    onClickNode(data) {
      this.selectedData = data;
    },
    // 관리타입 선택 이벤트 - 해당 타입에 맞는 트리로 재로드
    onChangeManagetypeId(value) {
      this.targetManagetypeId = value;
      if (value === 'NMS') {
        this.loadManagetypeKey(value);
      } else {
        this.managetypeKey = null;
      }
      this.reload();
    },
    // 트리 재로드
    reload() {
      this.reloadFlag = false;
      this.$nextTick(() => {
        this.reloadFlag = true;
      });
    },
    // 장비마법사 - 장비목록 삭제
    onDeleteServiceObj(row) {
      if (this.activeStep === 2) {
        const deleteIndex = this.serviceObjList.findIndex((data) => data.objId === row.objId);
        this.serviceObjList.splice(deleteIndex, 1);
        this.$refs.physicalObjTable.setCheckObjTable();
      } else {
        const deleteIndex = this.rscTableData.findIndex((data) => data.treeKey === row.treeKey);
        this.rscTableData.splice(deleteIndex, 1);
      }
    },
    onAddSelectedData() {
      if (this.activeStep === 2) {
        // obj들만 보내도록한다. map을 통해서 obj들만 list에 담아 보내자.
        const targetData = this.$refs[this.targetTreeRef].getFilteredCheckedNodes();
        targetData.map((item) => {
          if (item.obj && isEmpty(item.children)) {
            // 중복된 대상이 테이블에 들어가지 않게 분기처리한다.
            const duplCheck = this.serviceObjList.find((target) => target.objId === item.obj.objId);
            if (isUndefined(duplCheck)) {
              return this.serviceObjList.push(item.obj);
            }
          }
          return null;
        });
      } else {
        // 자원설정
        const targetData = this.$refs[this.rscTreeRef].getFilteredCheckedNodes();
        // const textarea = this.$refs[this.rscTreeRef].getCheckedNodes();
        targetData.map((item) => {
          if (item.leaf) {
            // 중복된 대상이 테이블에 들어가지 않게 분기처리한다.
            const duplCheck = this.rscTableData.find((target) => target.treeKey === item.treeKey);
            if (isUndefined(duplCheck)) {
              return this.rscTableData.push(item);
            }
          }
          return null;
        });
      }
    },
    /**
     * 서비스 등록 마법사 저장 이벤트
     * 2019. 09. 19 - 정적트리로 변경됨에 따라 수정
     *
     * @author Song
     * @return {Object} [response 객체]
     */
    onSaveButton() {
      this.formData.serviceConfigList = this.serviceObjList;
      const target = '서비스';
      if (this.wizardMode === 'add') {
        const action = msgUtil.action.REGIST;
        if (this.rscTableData.length > 0) {
          this.formData.serviceObjRscKeyList = this.rscTableData;
          this.isLoading = true;
          DeviceRegistrationSvcAPI.insertService(this.formData).then((response) => {
            const result = response.data;
            if (result.success === true) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.onBackToHomeButton();
              this.$emit('load-data');
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          }).finally(() => {
            this.isLoading = false;
          });
        } else {
          // 자원 설정 없이 장비연결 등록완료
          this.isLoading = true;
          DeviceRegistrationSvcAPI.insertService(this.formData).then((response) => {
            const result = response.data;
            if (result.success === true) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.onBackToHomeButton();
              this.$emit('load-data');
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          }).finally(() => {
            this.isLoading = false;
          });
        }
      } else {
        const params = {
          objId: this.formData.objId,
        };
        if (this.formData.objName !== this.formDataOrigin.objName) {
          params.objName = this.formData.objName;
        }
        if (this.formData.serviceDesc !== this.formDataOrigin.serviceDesc) {
          params.serviceDesc = this.formData.serviceDesc;
        }
        // 현재 objList들 정렬 값 부여
        forEach(this.serviceObjList, (item, index) => {
          item.orderbyIndex = index + 1;
        });

        // 서비스 장비연결 - 정렬 순서 업데이트 확인
        forEach(this.serviceObjList, (item) => {
          const targetIndex = findIndex(this.serviceObjListOrigin, ['objId', item.objId]);
          if (targetIndex >= 0 && item.orderbyIndex !== this.serviceObjListOrigin[targetIndex].orderbyIndex) {
            // 정렬 업데이트 대상
            this.updateOrderbyServiceObjList.push(item);
          }
        });

        // 서비스 장비연결 업데이트 리스트를 구분
        forEach(this.serviceObjListOrigin, (item) => {
          const targetIndex = findIndex(this.serviceObjList, ['objId', item.objId]);
          if (targetIndex < 0) {
            this.removeServiceObjList.push(item);
          } else {
            this.serviceObjList.splice(targetIndex, 1);
          }
        });

        // 서비스 자원연결 업데이트 리스트를 구분
        forEach(this.rscTableDataOrigin, (item) => {
          const targetIndex = findIndex(this.rscTableData, ['treeKey', item.treeKey]);
          if (targetIndex < 0) {
            this.removeRscTableData.push(item);
          } else {
            this.rscTableData.splice(targetIndex, 1);
          }
        });

        // 장비연결 리스트 정렬 업데이트 리스트
        params.updateOrderbyServiceObjList = this.updateOrderbyServiceObjList;

        // 서비스 장비 연결 업데이트, 삭제 리스트
        params.serviceConfigList = this.serviceObjList;
        params.removeServiceObjList = this.removeServiceObjList;

        // 서비스 자원 연결 업데이트, 삭제 리스트
        params.serviceObjRscKeyList = this.rscTableData;
        params.removeRscList = this.removeRscTableData;

        const action = msgUtil.action.SAVE;
        this.isLoading = true;
        DeviceRegistrationSvcAPI.updateServiceList(params).then((response) => {
          const result = response.data;
          if (result.success === true) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.onBackToHomeButton();
            this.$emit('load-data');
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).finally(() => {
          this.isLoading = false;
        });
      }
    },
    /**
     * 자원 설정 이벤트 - 선택한 장비에 대한 관련 서비스 자원을 트리형태로 표현한다.
     * 2019. 09. 19 - 기존 동적 트리를 정적트리로 변경
     *
     * @author Song
     * @return {Object} [response 객체]
     */
    onSettingObjRscLayer() {
      this.staticTreeLoadingFlag = true;
      this.$refs.rscSearchField.clear();
      this.activeStep = 3;
      this.targetTitle = `${this.formData.objName}`;
      this.rscReloadFlag = false;
      const objIds = [];
      forEach(this.serviceObjList, (item) => {
        objIds.push(item.objId);
      });
      // 2019. 09. 19 - 기존 동적 트리를 정적트리로 변경
      DeviceRegistrationSvcAPI.getSvcRscByStaticTree({ objIds }).then((res) => {
        if (res) {
          this.treeData = res.data.data;
          this.$nextTick(() => {
            this.rscReloadFlag = true;
            this.staticTreeLoadingFlag = false;
          });
        }
      });
    },
    /**
     * 2019. 09. 19 - 서비스 자원 - 정적트리로 변경되어 아래 동적트리 코드는 주석처리함
     *
     * @author Song
     * @return {Object}
     */
    // rscLoadData(node, resolve) {
    //   if (!isEmpty(node.data) && !isEmpty(node.data.children)) {
    //     resolve(node.data.children);
    //   }
    //   // 초기 로딩일 경우 OBJ 별 treeData 설정
    //   if (isEmpty(node.data)) {
    //     resolve(this.getSkeletonTreeData());
    //   } else if (node.data.level === 'RSC') {
    //     // RSC 레벨일 경우 파라미터 설정 후 데이터 호출
    //     const apiParam = {
    //       objId: node.data.objId,
    //       rsctypeId: node.data.rsctypeId,
    //     };
    //     DeviceRegistrationSvcAPI.getSvcForRscTreeData(apiParam).then((res) => {
    //       if (res.data.success) {
    //         const targetData = this.serviceObjList.find((item) => item.objId === node.data.objId);
    //         forEach(res.data.children, (item, index) => {
    //           res.data.children[index].objName = targetData.objName;
    //           res.data.children[index].rsctypeName = node.data.label;
    //           res.data.children[index].objId = node.data.objId;
    //           res.data.children[index].rsctypeId = node.data.rsctypeId;
    //           res.data.children[index].objManagetypeId = targetData.objManagetypeId;
    //         });
    //         resolve(res.data.children);
    //       }
    //     });
    //   }
    // },
    // getSkeletonTreeData() {
    //   const arr = [];
    //   this.serviceObjList.map((item) => {
    //     if (item.objManagetypeId === 'SMS' || item.objManagetypeId === 'NMS') {
    //       return arr.push(item);
    //     }
    //     return null;
    //   });
    //   const treeData = [];
    //   forEach(arr, (item) => {
    //     const data = {
    //       treeKey: `${item.objManagetypeId}.${item.objId}`,
    //       label: item.objName,
    //       level: 'OBJ',
    //     };
    //     // 각 타입에 따라 하위 RSC 레벨 트리 데이터 설정
    //     if (item.objManagetypeId === 'SMS') {
    //       data.children = [
    //         {
    //           objId: item.objId,
    //           treeKey: `${item.objId}.MAJORPROC`,
    //           label: '중요 프로세스',
    //           level: 'RSC',
    //           rsctypeId: 'MAJORPROC',
    //           children: [],
    //         },
    //         {
    //           objId: item.objId,
    //           treeKey: `${item.objId}.APPLOG`,
    //           label: '어플리케이션로그',
    //           level: 'RSC',
    //           rsctypeId: 'APPLOG',
    //           children: [],
    //         },
    //         {
    //           objId: item.objId,
    //           treeKey: `${item.objId}.SERVICE_PORT`,
    //           label: '서비스 포트',
    //           level: 'RSC',
    //           rsctypeId: 'SERVICE_PORT',
    //           children: [],
    //         },
    //       ];
    //     } else if (item.objManagetypeId === 'NMS') {
    //       data.children = [
    //         {
    //           objId: item.objId,
    //           treeKey: `${item.objId}.SYSLOG`,
    //           label: '시스로그',
    //           level: 'RSC',
    //           rsctypeId: 'SYSLOG',
    //           children: [],
    //         },
    //       ];
    //     }
    //     treeData.push(data);
    //   });
    //   return treeData;
    // },
    loadManagetypeKey(managetypeId) {
      managetypeKeyApi
        .getDisplayedManagetypeKeyList(managetypeId)
        .then((response) => {
          if (!isEmpty(response.data) && response.data.success === true && !isEmpty(response.data.data)) {
            this.managetypeKeyList = response.data.data;
            this.managetypeKey = this.managetypeKeyList[0].managetypeKey;
          } else {
            this.managetypeKeyList = null;
            this.managetypeKey = null;
          }
        })
        .catch(() => {
          this.managetypeKeyList = null;
          this.managetypeKey = null;
        });
    },
    rscFilterNode(value, data) {
      if (!value) return true;
      return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    filterTargetTree(value) {
      if (this.$refs[this.targetTreeRef]) {
        this.$refs[this.targetTreeRef].filterTree(value);
      }
    },
    filterRscTree(value) {
      if (this.$refs[this.rscTreeRef]) {
        this.$refs[this.rscTreeRef].filter(value);
      }
    },
  },
};
</script>

<style module>
.step-view {
  width: 100%;
  height: calc(100% - 163px);
}

.step-content {
  width: 100%;
  height: calc(100% - 59px);
}

.tree-box {
  display: inline-block;
  float: left;
  height: 100%;
  width: calc(50% - 58px);
}

.add-btn-box {
  display: inline-block;
  height: 100%;
  width: 50px;
}

.drag-box {
  display: inline-block;
  float: right;
  height: 100%;
  width: 50%;
}

.close-icon {
  float: right;
  line-height: 28px;
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Service/components/ServiceRegistWizard.vue